import React, { useEffect, useState } from 'react';
import { Globals as OldGlobals } from '../../global/Globals';
import '../../pages/ReviewProposals/ReviewProposalFooter.css';
import { useLanguage } from '../../context/Languagecontext';

const ReviewProposalFooter = ({ onCancelCreate, onSubmit, validate, validateDraft, onDraft }) => {
    const {Globals}=useLanguage();
    const [btnClassName, setBtnClassName] = useState('cancel-reg-btn register-btn-active');
   // const isAgreementChecked = useSelector(state => state.termsConditions.isAgreementChecked);
   // const isPolicyChecked = useSelector(state => state.termsConditions.isPolicyChecked);
    //const isButtonEnabled=isAgreementChecked&&isPolicyChecked?true:false;
    // useEffect(() => {
    //     if (isButtonEnabled) {
    //         setBtnClassName("register-btn-active")
    //     }
    //     else{
    //         setBtnClassName("disabled-btn");
    //     }
    // },[isButtonEnabled]);
    const cancelRegistration = () => {
        console.log("on cancelRegistration called..")

        if (onCancelCreate) {
            onCancelCreate();
        }
    }

    const onSubmitReview = () => {
        if(onSubmit){
          console.log("on submit called..")
          onSubmit();
        }
    }

    const onDraftReview=()=>{
        if(onDraft){
            onDraft();
        }
    }

    
    return (
        <div id="review-proposal-footer" className="review-proposal-footer">
            <div className="review-proposal-footer-btn-frame">
                <div className="review-proposal-footer-btn-group">
                    <span className="cancel-reg-btn" onClick={cancelRegistration}>{Globals.CLOSE}</span>
                    <button disabled={validateDraft} onClick={onDraftReview} id="review-proposal-draft-btn" className={"review-proposal-draft-btn-active"}>{Globals.APPLY_BRIEF.SAVE_AS_DRAFT}</button>
                    <button disabled={validate} onClick={onSubmitReview} id="review-proposal-submit-btn" className={"review-proposal-btn-active"}>{Globals.REVIEW_PROPOSALS.SUBMIT_REVIEW}</button>
                </div>
            </div>
        </div>
    );
}
export default ReviewProposalFooter;